import Vue from 'vue'
import VueRouter from 'vue-router'

import Home from '../views/Home'
import Products from '../views/Products'
import ProductDetail from '../views/ProductDetail'
import ProjectShow from '../views/ProjectShow'
import ContactUs from '../views/ContactUs'
import DownLoad from '../views/DownloadPage.vue'
import AboutUs from '../views/AboutUs.vue'

import NavHome from '../components/nav/Home.vue';
import NavIndex from '../components/nav/Index.vue';
import NavPatch from '../components/nav/Patch.vue';
import NavHelloWorld from '../components/nav/HelloWorld.vue'
import NavContent from '../components/nav/CustomTable.vue'

Vue.use(VueRouter)

const routes = [
	{
		path: '/',
		name: 'Edge Home',
		component: Home,
		meta: {
			title: '爱智控制 || 大连爱智控制有限公司',
		},
	},
	{
		path: '/products',
		name: 'Edge Products',
		component: Products,
		meta: {
			title: '产品中心 || 大连爱智控制有限公司',
		},
	},
	{
		path: '/products/:categoryID',
		name: 'Edge Products With ID',
		component: Products,
		meta: {
			title: '产品中心 || 大连爱智控制有限公司',
		},
	},
	{
		path: '/product-detail',
		name: 'Edge Product Detail',
		component: ProductDetail,
		meta: {
			title: '产品详细 || 大连爱智控制有限公司',
		},
	},
	{
		path: '/product-detail/:typeID',
		name: 'Edge Product Detail With ID',
		component: ProductDetail,
		meta: {
			title: '产品详细 || 大连爱智控制有限公司',
		},
	},
	// {
	// 	path: '/project-show',
	// 	name: 'Edge Project Show',
	// 	component: ProjectShow,
	// 	meta: {
	// 		title: '实施案例详细 || 大连爱智控制有限公司',
	// 	},
	// },
	{
		path: '/project-show/:caseID',
		name: 'Edge Project Show With ID',
		component: ProjectShow,
		meta: {
			title: '实施案例详细 || 大连爱智控制有限公司',
		},
	},
	{
		path: '/contact-us',
		name: 'Edge Contact',
		component: ContactUs,
		meta: {
			title: '联系我们 || 大连爱智控制有限公司',
		},
	},
	{
		path: '/download',
		name: 'downloadHome',
		component: DownLoad,
		showMenu: true,
		redirect: '/download/software/cfgPr',
		meta: {
			icon: 'el-icon-location',
			title: '资源下载 || 大连爱智控制有限公司',
		},
		children: [
			// {
			// 	path: '/download/index',
			// 	name: '常用',
			// 	component: NavContent,
			// 	showMenu: true,
			// 	meta: {
			// 		icon: 'el-icon-s-grid',
			// 		keepAlive: false,
			// 		title: '常见列表 || 大连爱智控制有限公司',
			// 	}
			// },
			{
				path: '/download/software',
				name: '软件',
				component: NavPatch,
				showMenu: true,
				meta: {
					icon: 'el-icon-remove',
				},
				children:[
					{
						path: '/download/software/cfgPr',
						name: '组态编程',
						component: NavContent,
						showMenu: true,
						meta: {
							icon: 'el-icon-s-data',
							keepAlive: true,
							title: '下载组态编程软件 || 大连爱智控制有限公司',
							downSign:'cfgPr'
						}
					},
					{
						path: '/download/software/pdebgSw',
						name: '产品调试软件',
						component: NavContent,
						showMenu: true,
						meta: {
							icon: 'el-icon-s-data',
							keepAlive: true,
							title: '下载产品调试软件 || 大连爱智控制有限公司',
							downSign:'pdebgSw'
						}
					},
					{						
						path: '/download/software/tools',
						name: '小工具',
						component: NavContent,
						showMenu: true,
						meta: {
							icon: 'el-icon-s-data',
							keepAlive: true,
							title: '下载软件小工具 || 大连爱智控制有限公司',
							downSign:'tools'
						}						
					}
				]
			},
			{
				path: '/download/files',
				name: '说明文档',
				component: NavPatch,
				showMenu: true,
				meta: {
					icon: 'el-icon-remove',
				},
				children:[
					{
						path: '/download/files/guide',
						name: '选型指导',
						component: NavContent,
						showMenu: true,
						meta: {
							icon: 'el-icon-s-data',
							keepAlive: true,
							title: '下载选型指导 || 大连爱智控制有限公司',
							downSign:'guide'
						}
					},
					{
						path: '/download/files/manual',
						name: '产品使用说明',
						component: NavContent,
						showMenu: true,
						meta: {
							icon: 'el-icon-s-data',
							keepAlive: true,
							title: '下载产品使用说明 || 大连爱智控制有限公司',
							downSign:'manual'
						}	
					},
					{
						path: '/download/files/techDoc',
						name: '技术文档',
						component: NavContent,
						showMenu: true,
						meta: {
							icon: 'el-icon-s-data',
							keepAlive: true,
							title: '下载技术文档 || 大连爱智控制有限公司',
							downSign:'techDoc'
						}	
					}
				]
			},
			{
				path: '/download/samples',
				name: '示例',
				component: NavPatch,
				showMenu: true,
				meta: {
					icon: 'el-icon-remove',
				},
				children:[
					{
						path: '/download/files/driver',
						name: '驱动示例',
						component: NavContent,
						showMenu: true,
						meta: {
							icon: 'el-icon-s-data',
							keepAlive: true,
							title: '下载驱动示例 || 大连爱智控制有限公司',
							downSign:'driver'
						}
					},
					{
						path: '/download/files/communiate',
						name: '通讯示例',
						component: NavContent,
						showMenu: true,
						meta: {
							icon: 'el-icon-s-data',
							keepAlive: true,
							title: '下载通讯示例 || 大连爱智控制有限公司',
							downSign:'communiate'
						}
					}
				]
			},
		]
	},
	{
		path: '/about-us',
		name: 'Edge About',
		component: AboutUs,
		meta: {
			title: '关于我们 || 大连爱智控制有限公司',
		},
	}	
]

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes
})

router.beforeEach((to, from, next) => {
	document.title = to.meta.title;
	next();
	window.scrollTo(0, 0)
});

export default router
